import { useConfirmDialog } from '@vueuse/core';

import { createInjectionStateOrThrow } from '@abaninja/utils';

export type Data = {
  message?: string | (string | { itemProps?: Record<string, any>; message: string })[];
  noBtnText?: string;
  title?: string;
  yesBtnText?: string;
};

export const [provideConfirmationDialog, useConfirmationDialog] = createInjectionStateOrThrow(
  'ConfirmationDialog',
  useConfirmDialog<Data, never, never>,
);
